import { render, staticRenderFns } from "./TabPriceMatch.vue?vue&type=template&id=771cfcb7&"
import script from "./TabPriceMatch.vue?vue&type=script&lang=js&"
export * from "./TabPriceMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports